
export const svgStyles = {

    primaryStyle: {
        fill: 'var(--mui-palette-primary-main)',
        filter: 'contrast(0.8) brightness(1.2)'
    },
    secondaryStyle: {
        fill: 'var(--mui-palette-secondary-main)'
    },
    secondaryText: {
        fill: 'var(--mui-palette-secondary-textIconColor)'
    }

}